// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1antG","content":"styles_content__38rBw","row":"styles_row__XKbet","footer":"styles_footer__ypMMS","phraseLength":"styles_phraseLength__dNF3X"};